import { createFileRoute } from '@tanstack/react-router'

import { HubspotSyncScreen } from './-components/hubspot-sync-screen.tsx'

export const Route = createFileRoute('/merchants/hubspot-sync')({
  component: HubspotSyncScreen
})
